import CloseIcon from '../../assets/icons/close.svg?react';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useEffect, useState } from 'react';
import type { FC, PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  isOpen: boolean;
  onClose(): void;
  title?: string;
}>;

export const BottomSheet: FC<Props> = ({
  children,
  isOpen,
  onClose,
  title,
}) => {
  // Prevent SSR mismatch + keep it simple
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  if (!mounted) return null;

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={onClose}
        unmount={false}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/60" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 flex items-end justify-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="translate-y-full"
              enterTo="translate-y-0"
              leave="ease-in duration-200"
              leaveFrom="translate-y-0"
              leaveTo="translate-y-full"
            >
              <Dialog.Panel className="relative w-full rounded-t-3xl bg-white pb-[max(env(safe-area-inset-bottom),16px)] shadow-[0px_-8px_24px_rgba(0,0,0,0.12)]">
                <div className="flex items-center justify-between gap-[12px] px-[20px] pt-[16px]">
                  <div className="flex min-w-0 flex-1 items-center gap-[12px]">
                    {title ? (
                      <Dialog.Title className="min-w-0 flex-1 truncate text-[24px] font-medium leading-6 text-[#151515]">
                        {title}
                      </Dialog.Title>
                    ) : (
                      <div className="min-w-0 flex-1" />
                    )}
                  </div>
                  <button
                    type="button"
                    aria-label="Закрыть"
                    onClick={onClose}
                    className="flex size-[44px] items-center justify-center rounded-[50%] bg-[#f1f7fa]"
                  >
                    <CloseIcon />
                  </button>
                </div>

                <div className="p-[24px]">{children}</div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};
